import { Button, Stack, Typography, useTheme } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { Gps01Icon, House04Icon } from "@hugeicons/core-free-icons";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { openLocationDialog } from "@/store/uiSlice";
import { setDeliveryLocation } from "@/features/order/slice";
import { RootState } from "@/store/store";

const MissingDeliveryLocationBanner = () => {
    const { palette } = useTheme();
    const dispatch = useAppDispatch();
    const order = useAppSelector((state: RootState) => state.order);

    const handleOpen = () => {
        dispatch(openLocationDialog());
    };

    const handleUseGPS = () => {
        if (!navigator.geolocation) {
            alert("La geolocalización no es compatible con este navegador.");
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                dispatch(setDeliveryLocation({
                    ...order.deliveryLocation,
                    latitude,
                    longitude,
                }));
            },
            (error) => {
                console.error("Error getting location:", error);
            },
            {
                enableHighAccuracy: true,
            }
        );
    };

    return (
        <Stack alignItems="center" spacing={1} pt={3} pb={1}>
            <HugeiconsIcon icon={House04Icon} size={54} strokeWidth={1} color={palette.primary.main} />
            <Stack>
                <Typography textAlign="center" variant="h3">¿Dónde deseas recibir tu pedido?</Typography>
                <Typography textAlign="center">Agrega tu dirección para calcular el costo del envío</Typography>
            </Stack>
            <Stack direction="row" spacing={2} width="100%" justifyContent="center" sx={{ paddingX: 5, boxSizing: "border-box" }}>
                {!navigator.geolocation ? (
                    <Button
                        variant="contained"
                        onClick={handleUseGPS}
                        startIcon={<HugeiconsIcon icon={Gps01Icon} size={18} strokeWidth={1} />}
                    >
                        Detectar
                    </Button>
                ) : null}
                <Button onClick={handleOpen}>
                    Agregar ubicación
                </Button>
            </Stack>
        </Stack>
    );
};

export default MissingDeliveryLocationBanner;